export const CLEANER_CLEAN_STORE = 'CLEANER_CLEAN_STORE';
export const CLEANER_CLEAN_REDUCERS = 'CLEANER_CLEAN_REDUCERS';
